import React from 'react'

import { FlowRoute } from 'utils/FlowProvider/types'

export const CORE_HERO_COPY = new Map([
  [
    FlowRoute.Signup,
    {
      header: 'Create account',
      text: (
        <>
          Acorns is your guide to growing your financial knowledge. We’ll help you invest, save and
          bank smarter starting at just <strong>$1 per month.</strong>
        </>
      ),
      footnote: 'Protected by bank-level security',
      footnoteLock: true,
    },
  ],
  [
    FlowRoute.Funding,
    {
      header: 'Link your bank',
      text: 'To seamlessly deposit and withdraw money, securely link your bank now.',
    },
  ],
  [
    FlowRoute.Institutions,
    {
      header: 'Log into your bank',
      text: 'Protected by bank-level security and 256-bit encryption.',
    },
  ],
  [
    FlowRoute.ManualFundingSource,
    {
      header: 'Link your bank account',
      text:
        'We need a little more information to link your bank account, so you can fund your investments.',
      footnote: 'Your data is protected with 256-bit encryption',
      footnoteLock: true,
    },
  ],
  [
    FlowRoute.PersonalInfo,
    {
      header: 'Personal information',
      text: 'Acorns is required to collect this information to open your account.',
      footnote: 'Your data is protected with 256-bit encryption',
      footnoteLock: true,
    },
  ],
  [
    FlowRoute.SuitabilityQuestions,
    {
      header: 'Your finances and goals',
      text:
        'Tell us a little about your current financial situation so we can recommend the best investment portfolio for you.',
    },
  ],
  [
    FlowRoute.ContactInfo,
    {
      header: 'Contact information',
      text: 'Acorns is required to collect this information to open your account.',
      footnote: 'Your data is protected with 256-bit encryption',
      footnoteLock: true,
    },
  ],
  [
    FlowRoute.InvestInterstitial,
    {
      header: "Let's set up your Invest account",
      text:
        'These 7 quick questions help us recommend the best investment portfolio for you and your money goals.',
      disclaimer:
        'We use bank-level security, the highest levels of data encryption, and your information is never stored on your device.',
      ctaLabel: 'Next',
    },
  ],
  [
    FlowRoute.InvestorQuestions,
    {
      header: 'More About You',
      text:
        'While these investor questions don’t apply to most people, let us know if any apply to you.',
    },
  ],
  [
    FlowRoute.OneTimeInvestment,
    {
      header: 'One-time Investment',
      text: 'Pick an amount to jumpstart your account today.',
    },
  ],
  [
    FlowRoute.RecurringInvestment,
    {
      header: 'Recurring Investment',
      text:
        'You’re about to become an investor! Set a weekly recurring investment to supercharge your account. You can always change this later.',
    },
  ],
  [
    FlowRoute.BankLinkSuccess,
    {
      header: 'Successfully linked',
      text:
        'Every time you add money to Acorns, it will transfer from your primary checking account.',
      subtext: 'The money to fund your investments will come from your linked account.',
    },
  ],
  [
    FlowRoute.RoundUpsInterstitial,
    {
      header: 'Round-Ups® are on',
      text:
        "Every time you buy something, like gas or coffee, we'll round the purchase up to the next dollar and invest it for you. Just link your debit or credit cards and we’ll take it from there.",
      disclaimer: 'You can turn Round-Ups® off in settings at anytime',
      ctaLabel: 'Continue',
    },
  ],
])
